import React from "react";
import { useForm, Controller } from "react-hook-form";
import { Box } from "@mui/material";
import { useForgetPassword } from "../../hooks/useForgetPassword";
import { renderErrorMessage } from "../../utils";
import Modal from "../Modal/Modal.view";
import { InputField } from "@dishopsaas/design-system";
import {
  ForgetPasswordFormData,
  ForgetPasswordProps,
} from "../../1_types/signinTypes";
import { EMAIL_REGEX } from "../../constants/regex";

const ForgetPassword: React.FC<ForgetPasswordProps> = ({
  onSubmit,
  errorMessage,
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<ForgetPasswordFormData>({
    mode: "onTouched",
  });

  const { loadingResetPassword, handleShowForgetPassword } =
    useForgetPassword();

  const submitForm = (data: ForgetPasswordFormData) => {
    onSubmit(data.email);
  };

  return (
    <form onSubmit={handleSubmit(submitForm)}>
      <Modal
        title="MOT DE PASSE OUBLIÉ ?"
        subtitle="Nous vous enverrons un lien pour réinitialiser votre mot de passe."
        icon="forgetPassword"
        isLoading={loadingResetPassword}
        formContent={
          <Controller
            name="email"
            control={control}
            rules={{
              required: "Email est requis",
              pattern: {
                value: EMAIL_REGEX,
                message: "Email invalide",
              },
            }}
            render={({ field }) => (
              <Box>
                {errorMessage && (
                  <Box sx={{ mb: 2, color: "error.main" }}>
                    {renderErrorMessage(errorMessage)}
                  </Box>
                )}
                <InputField
                  {...field}
                  type="email"
                  label="Adresse e-mail"
                  placeholder="email@gmail.com"
                  error={!!errors.email}
                  helperText={errors.email?.message}
                />
              </Box>
            )}
          />
        }
        primaryButton={{
          label: "ENVOYER LE LIEN DE RÉINITIALISATION",
          type: "submit",
          disabled: !isValid,
        }}
        secondaryButton={{
          label: "REVENIR À LA CONNEXION",
          onClick: () => handleShowForgetPassword(false),
        }}
      />
    </form>
  );
};

export default ForgetPassword;
